import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthUtil } from './auth-util';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { timeout, tap } from 'rxjs/operators';
import { TokenRequest } from './token-request';
import { environment } from "../../environments/environment";
import { AccessToken } from './access-token';
import { Observable } from 'rxjs';
 
//This class will check for token availablity, if not redirects log in page.
@Injectable()
export class AzureAuthGuard implements CanActivate {

    constructor(private router: Router, private http: HttpClient) { }
 
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        
        if(!environment.AZURE_LOGIN_NEEDED) {
            return true
        }
        
        let loginFailureMessage = 'Login expired/Failed! Please logout and try again'
        let access_key_expiration_buffer = 10
        let util = new AuthUtil()
        this.checkIfLogginStatus()

        if (localStorage.getItem('token')) {   

            if(localStorage.getItem('token') != 'in_progress') {
    
                //let token: AccessToken = JSON.parse(localStorage.getItem('token'))
                if(util.isLoggedIn() && !util.isLoginExpired()) {
                    return true
                } else {
                    alert(loginFailureMessage)
                    return false
                }
            
            } else if(localStorage.getItem('token') === 'in_progress') {
                
                let queryParam = util.parseQueryString(window.location.search.substring(1))
                
                //Auth code is not sent by Azure AD
                if(queryParam.code === undefined) {
                    util.redirectToAzureLogin()
                    return false
                } else {

                    //state is matched with the value it was redirected with. It may indicate request may have 
                    //been tampered with
                    if(!queryParam.state || queryParam.state != localStorage.getItem('pkce_state')) {
                        return false
                    }

                    if(queryParam.code) {
                        this.requestForToken(queryParam)
                            .subscribe(token => {
                                let current_date = new Date()
                                current_date.setSeconds(current_date.getSeconds() + token.expires_in - access_key_expiration_buffer)
                                token.expire_at = current_date
                                localStorage.setItem('token', JSON.stringify(token))
                                
                                return this.router.navigate(['/lab'])
                            }, error => {
                                localStorage.removeItem('token')
                                return false
                            })
                    }
                    
                }
                
            }
                    
        } else {
            
            localStorage.setItem('token', 'in_progress')
            util.redirectToAzureLogin()
            
        }

    }

    

    /**
     * Preparing request to retrieve access token using auth code.
     * @param authCode 
     */
    requestForToken(authCode): Observable<AccessToken> {

        let authUtil = new AuthUtil()
    
        let request = new TokenRequest()
        request.client_id = authUtil.base64urlencode(environment.AZURE_BBUI_CLIENT_ID) //'228d410f-af88-4d80-91d0-9674b672d415'
        request.grant_type = authUtil.base64urlencode('authorization_code')
        request.redirect_uri = authUtil.base64urlencode(environment.AZURE_BBUI_REDIRECT_URL_AFTER_LOGIN)//'http%3A%2F%2Flocalhost%3A4200'
        request.code_verifier = authUtil.base64urlencode(localStorage.getItem('pkce_code_verifier'))//'462d7acf7cbd940407fbd361f78e384e9f3e06dd2e9db743661abc97'
        request.code = authUtil.base64urlencode(authCode.code)
        request.response_type = authUtil.base64urlencode('code')
        request.state = authUtil.base64urlencode(localStorage.getItem('pkce_state'))
        request.scope = authUtil.base64urlencode(environment.AZURE_AUTHORIZATION_SCOPE) //'user.read%20openid%20profile%20api%3A%2F%2F84c32493-ba89-423e-8b6d-d6997421fad3%2Fbuild.info.authgrant'
        
        return this.retrieveAccessToken(request)
    
    }

    /**
     * HTTP post request to retrieve Access Token
     * @param request 
     */
    retrieveAccessToken(request): Observable<AccessToken> {
        let tokenServiceUrl = environment.AZURE_TOKEN_URL //'https://login.microsoftonline.com/' + 'f3983b48-9cf8-4afa-a6fc-e2aaa8c7ec9c/oauth2/v2.0/token'
                       
        let tokenHeader = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }) 
        }

        let tokenRequestBody = `client_id=${request.client_id}` 
                + `&response_type=${request.response_type}` 
                + `&redirect_uri=${request.redirect_uri}`
                + `&response_mode=query` 
                + `&state=${request.state}` 
                + `&grant_type=${request.grant_type}` 
                + `&code=${request.code}`
                + `&code_verifier=${request.code_verifier}` 
                + `&scope=${request.scope}`

        
        return this.http.post<AccessToken>(tokenServiceUrl, tokenRequestBody, tokenHeader)
                 .pipe(timeout(10000), tap(token => {}, error => {}));
                
    }


    /**
     * @description 
     * 
     * 1. Check if logged in and login expires in next 10 min 
        a. Yes - If refresh token is present confirm if user would like to extend his session
            i.  Yes - Ask for new access token in background.
            ii. No - Don't do anything
        
        b. No - Alert they will be logged out in 10 min
    
       2. Check if login already expired 
        a. Yes - Alert that the user will be logged out
    */
    checkIfLogginStatus() {
        const util = new AuthUtil()
        if (util.isLoggedIn() && util.isLoginExpired()) {
            alert('Your login expired ! We are logging you out')
            util.logout()
            //this.router.navigate([''])
        }

        if (util.isLoggedIn() && util.isLoginGoingToExpireIn30min()) {
            const refresh_token = util.getRefreshToken()
            if (refresh_token == null) {
                alert('Your login expired ! We are logging you out')
                util.logout()
                //this.router.navigate([''])
            } 
        }

    }
   
}